export const dataPostCodeDefault = {
  amount: 0,
  eventId: 0,
  useTime: 0,
  expiresAt: '',
};
